var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebookF3A95533Ef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 0.5C5.87299 0.5 0.500488 5.8725 0.500488 12.5C0.500488 19.1275 5.87299 24.5 12.5005 24.5C19.128 24.5 24.5005 19.1275 24.5005 12.5C24.5005 5.8725 19.128 0.5 12.5005 0.5ZM15.343 8.7925H13.5392C13.3255 8.7925 13.088 9.07375 13.088 9.4475V10.75H15.3442L15.003 12.6075H13.088V18.1838H10.9592V12.6075H9.02799V10.75H10.9592V9.6575C10.9592 8.09 12.0467 6.81625 13.5392 6.81625H15.343V8.7925Z",
    fill: "#F1F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookF3A95533Ef);
export default __webpack_public_path__ + "static/media/icon_facebook_f3a95533ef.c9b402e1bdd95414df8714acf94f0465.svg";
export { ForwardRef as ReactComponent };